<script lang="ts" module>
  import CtaButton from '@/ui/elements/buttons/CTAButton.svelte';
  import { useTeoCore } from '@/utils/teo-context';

  export type Factor168SentimentResponse = {
    model: string;
    results: {
      [key: string]: number | undefined;
    } | null;
    text: string;
    timestamp: number;
  };
</script>

<script lang="ts">
  const core = useTeoCore();
  let error = $state<string | undefined>();
  let loading = $state(false);
  let lastResponse = $state<Factor168SentimentResponse | undefined>();

  function sendRequest() {
    error = undefined;
    loading = true;
    const text = core.activeText.text;
    const request = {
      text,
    };
    console.log('Sending request:', request);
    core.api
      .authenticatedPost<Factor168SentimentResponse>('factor168/sentiment', request)
      .then((response) => {
        console.log('Response:', response);
        if (response.ok) {
          lastResponse = response.json as Factor168SentimentResponse;
        } else {
          error = response.error?.message || 'Ein Fehler ist aufgetreten.';
        }
      })
      .catch((err) => {
        console.error(err);
        error = err.message || 'Ein Fehler ist aufgetreten.';
      })
      .finally(() => {
        loading = false;
      });

    // Response Example:
    //{
    //   "model": "gpt-4-turbo-preview",
    //     "results": {
    //         "business_opportunity": 0.6,
    //         "emotional_urgency": 0.3,
    //         "price_sensitivity": 0.8,
    //         "purchase_intent": 0.7,
    //         "service_complexity": 0.1
    //     },
    //     "text": "I love this product but the price is too high!",
    //     "timestamp": 1755528420
    // }
  }
</script>

<div class="mb-1 font-bold">Sentiment:</div>
<CtaButton type="submit" {loading} onclick={sendRequest} class="self-stretch">Senden</CtaButton>
{#if error}
  <div class="rounded bg-red-100 text-red-800 mt-2 p-2 text-sm">{error}</div>
{/if}
{#if lastResponse}
  <div class="rounded bg-c-bg mt-4 border p-3">
    <ul class="list-disc pl-5">
      {#if lastResponse.results}
        {#each Object.entries(lastResponse.results) as [key, value] (key)}
          <li><span class="font-mono">{key}</span>: {value}</li>
        {/each}
      {:else}
        <li>Keine Ergebnisse gefunden.</li>
      {/if}
    </ul>
  </div>
{:else}
  <div class="rounded bg-c-bg mt-4 border p-3">Noch keine Antwort erhalten.</div>
{/if}
